export default __webpack_public_path__ + "static/media/Note-Taker.06037ef5.PNG";